import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';

const PRODUCT_IMAGES = {
  'Акватория': '/aquatory.png',
  'Ладица': '/ladica.png',
};

const PRODUCT_CERTS = {
  'Акватория': '/aquatory_cert.pdf',
  'Ладица': '/ladica_sert.pdf',
};

function InfoRow({ label, value }) {
  if (!value) return null;
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: 6, paddingBottom: 6, borderBottom: '1px solid var(--border)' }}>
      <span style={{ fontSize: 14, color: 'var(--text-light)' }}>{label}</span>
      <span style={{ fontSize: 14, color: 'var(--text)', fontWeight: 600, textAlign: 'right', maxWidth: '60%' }}>{value}</span>
    </div>
  );
}

export default function WaterDetailScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const { getCatalogUnitPrice } = useAppContext();
  const product = location.state?.product;
  const billingUnitPrice = product ? (Number(product.price) || 0) : 0;
  const catalogUnitPrice = product ? getCatalogUnitPrice(product) : 0;

  if (!product) return (
    <div style={{ padding: 24 }}>
      <button onClick={() => navigate('/catalog')} style={backBtn}>← В каталог</button>
      <p>Товар не найден</p>
    </div>
  );

  return (
    <div style={{ padding: '0 16px 100px' }}>
      <button onClick={() => navigate(-1)} style={backBtn}>← Назад</button>

      {/* Герой */}
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '40px 0 24px' }}>
        {PRODUCT_IMAGES[product.brand] ? (
          <img src={PRODUCT_IMAGES[product.brand]} alt={product.brand} style={{ width: 160, height: 200, objectFit: 'contain', borderRadius: 16, marginBottom: 12 }} />
        ) : (
          <span style={{ fontSize: 72, marginBottom: 12 }}>{product.emoji || '💧'}</span>
        )}
        <h1 style={{ fontSize: 26, fontWeight: 'bold', color: 'var(--primary)', marginBottom: 4 }}>{product.brand}</h1>
        <p style={{ fontSize: 15, color: 'var(--text-light)', marginBottom: 4 }}>{product.volume}</p>
        <p style={{ fontSize: 24, fontWeight: 'bold', color: 'var(--text)' }}>{billingUnitPrice} ₽<span style={{ fontSize: 14, fontWeight: 600, color: 'var(--text-light)' }}> / баллон</span></p>
        <p style={{ fontSize: 13, color: 'var(--text-light)', marginTop: 6, textAlign: 'center', maxWidth: 280 }}>в каталоге от {catalogUnitPrice} ₽ · скидка за обмен пустой бутыли 280 ₽</p>
      </div>

      {/* О продукте */}
      {product.about && (
        <div style={cardStyle}>
          <h3 style={cardTitle}>📖 О продукте</h3>
          <p style={{ fontSize: 14, color: 'var(--text-light)', lineHeight: 1.6 }}>{product.about}</p>
        </div>
      )}

      {/* Происхождение */}
      {(product.country || product.region || product.source) && (
        <div style={cardStyle}>
          <h3 style={cardTitle}>📍 Происхождение</h3>
          <InfoRow label="Страна" value={product.country} />
          <InfoRow label="Регион" value={[product.region, product.source].filter(Boolean).join(', ')} />
        </div>
      )}

      {/* Сертификация */}
      {(product.certificate || PRODUCT_CERTS[product.brand]) && (
        <div style={cardStyle}>
          <h3 style={cardTitle}>✅ Сертификация</h3>
          {product.certificate && <p style={{ fontSize: 14, color: 'var(--text-light)', lineHeight: 1.6, marginBottom: 8 }}>{product.certificate}</p>}
          {PRODUCT_CERTS[product.brand] && (
            <a href={PRODUCT_CERTS[product.brand]} target="_blank" rel="noreferrer"
              style={{ display: 'block', textAlign: 'center', padding: '10px', borderRadius: 10, border: '1.5px solid var(--primary)', color: 'var(--primary)', fontWeight: 700, fontSize: 14, textDecoration: 'none' }}>
              📄 Открыть протокол испытаний
            </a>
          )}
        </div>
      )}

      {/* Кнопка заказа */}
      <button
        onClick={() => navigate('/order', { state: { product } })}
        style={{ display: 'block', width: '100%', padding: 14, borderRadius: 14, background: 'var(--primary)', color: '#fff', fontSize: 16, fontWeight: 700, marginTop: 8, cursor: 'pointer' }}
      >
        Заказать — от {billingUnitPrice} ₽
      </button>
    </div>
  );
}

const backBtn = { background: 'none', color: 'var(--primary)', fontSize: 16, marginTop: 16, marginBottom: 8, cursor: 'pointer', padding: 0 };
const cardStyle = { background: 'var(--card)', borderRadius: 14, padding: 16, marginBottom: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' };
const cardTitle = { fontSize: 15, fontWeight: 700, color: 'var(--text)', marginBottom: 12 };
